<template>
	<div v-bind="c_test_attrs">
		<editor v-model="c_value" :init="editorConfig" :id="CTRL_ID" />

		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>

		<modal :visible.sync="show_popup" v-if="show_popup" :wide="true">
			<div slot="header" class="row">
				<div class="col-md-12">
					<!-- <h4>Выберите запись</h4> -->
				</div>
				<div class="col-md-12 text-right">
					<a class="btn btn-default" @click="show_popup = false">Закрыть</a>
				</div>
			</div>
			<div slot="body" v-if="$data.modalComponentName">
				<component
					:is="$data.modalComponentName"
					v-bind="$data.modalComponentProps"
					@popup_select="modalComponentOnEventProxy"
					@popup_upsert="modalComponentOnEventProxy"
				/>
				<!--
					popup_select - выбор записи в попапе, аргументом получается запись
					popup_upsert - создание/обновление записи в попапе, арг. - список записей
				-->
			</div>
		</modal>
	</div>
</template>

<script>
/**
		Компонент визуального редактора
		https://github.com/tinymce/tinymce-vue
	*/
import ctrlMixins from './../_mixins.js';

// TODO ленивая подгрузка https://vuedose.tips/tips/dynamic-imports-in-vue-js-for-better-performance/
// const editor = () => import('@tinymce/tinymce-vue');
import editor from '@tinymce/tinymce-vue';

import getEditorConfig from './getEditorConfig.js';
import modal from '@uarm/src/modal.vue';

import tinymce from 'tinymce/tinymce.min.js';
import 'tinymce/themes/modern/theme.min.js';
import { ctrlParamsForAll } from './../_common-stuff.ts';

// эти ресурсы будут скопированы в dist/uarm-css и dist/uarm-fonts
import '@uarm/public/css/tinymce/skin.min.css';
import '@uarm/public/css/tinymce/content.min.css';
import '@uarm/public/css/tinymce/innerStyle.css';
import '@uarm/public/css/tinymce/innerStyle-base.css';
//import '@uarm/public/images/loader.gif';
import '@uarm/public/fonts/tinymce.eot';
import '@uarm/public/fonts/tinymce-small.eot';
import '@uarm/public/fonts/tinymce.ttf';
import '@uarm/public/fonts/tinymce-small.ttf';
import '@uarm/public/fonts/tinymce.woff';
import '@uarm/public/fonts/tinymce-small.woff';
import '@uarm/public/fonts/tinymce.svg';
import '@uarm/public/fonts/tinymce-small.svg';

window.tinymce = window.tinymce || tinymce;
// tinymce-vue требует глобальную переменную, от так от
// но можно сделать через лоадер https://github.com/tinymce/tinymce/issues/2836#issue-146644654

export default {
	name: 'ctrl_wysiwyg',
	meta: {
		// это наши данные, т.е. вуй при объявлении компонента их не использует
		title: 'Визуальный редактор',
		params: {
			isEmail: {
				name: 'Для рассылок',
				editType: 'checkbox',
			},
			isCompact: {
				name: 'Компактный',
				editType: 'checkbox',
			},
			...ctrlParamsForAll,
		},
	},
	mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	props: {
		// большая часть пропсов приезжает из ctrlMixins!
		value: {
			default: '',
		},
		// TODO сделать обработку is_disabled https://stackoverflow.com/questions/13881812/make-readonly-disable-tinymce-textarea
	},
	data: function () {
		var CTRL_ID = 'CTRL_ID__' + Math.floor(Math.random() * 1e17);
		return {
			CTRL_ID, // можно получить инстанс редактора через window.tinymce.get(CTRL_ID)
			show_popup: false,
			tinymceInstance: null,
			editorConfig: getEditorConfig(this, CTRL_ID),
		};
	},
	methods: {
		openArm: function (propsToPass, getValueHandler, isCard) {
			this.$data.show_popup = true;
			this.$data.modalComponentName = isCard ? 'global-component-page-list' : 'global-component-page-card';
			this.$data.modalComponentProps = propsToPass;
			this.modalComponentOnEvent = getValueHandler;
		},
		modalComponentOnEventProxy: function () {
			// прокси-метод который выполняет динамический метод _nonReactiveHelper для вбивания выбранного значения
			this.modalComponentOnEvent.apply(this, arguments);
			this.$data.show_popup = false;
			this.$data.modalComponentName = null;
			this.$data.modalComponentProps = null;
			this.$data.modalComponentOnGetValue_nonReactiveHelper = null;
		},
		_detectBrokenLinks() {
			const text = this.tinymceInstance.getContent();

			const links = this.brokenLinks.map((url) => {
				let parseResult = new DOMParser().parseFromString(url, 'text/html');
				return parseResult.documentElement.textContent;
			});

			// console.log('Start detect broken links', this.CTRL_ID, this.brokenLinks, text)
			const modifier = addClassBrokenLink(text, links, this.CTRL_ID);
			this.tinymceInstance.setContent(modifier);
		},
	},
	mounted: function () {
		var tinymceInstance = window.tinymce.get(this.$data.CTRL_ID);

		if (!tinymceInstance) {
			console.warn(`Не найден инстанс tinymce ctrl_id=${this.$data.CTRL_ID}`);
			return;
		}

		this.tinymceInstance = tinymceInstance;
		tinymceInstance.CUSTOM__openArm = this.openArm; // см. getEditorConfig

		// console.log('mounted', this.CTRL_ID, this.brokenLinks)
		if (this.brokenLinks && this.brokenLinks.length) {
			setTimeout(() => this._detectBrokenLinks(), 1000);
		}

		// initWatchToChangeTheme(
		// 	this.$refs.iframeRef.contentWindow.document.getElementsByTagName("body")[0]
		// )
	},
	components: {
		editor,
		modal,
	},
	watch: {
		c_value: function (v) {
			this.mixin_inputEvent(); // для черновиков. Попытка поместить это на событие браузера закончилась провалом
		},
		brokenLinks: function (v) {
			if (v && v.length) {
				setTimeout(() => this._detectBrokenLinks(), 1000);
			}
		},
	},
};

function addClassBrokenLink(text, links, CTRL_ID) {
	const el = document.createElement('div');
	el.innerHTML = text;

	for (let i = 0, l = el.childNodes.length; i < l; i++) {
		if (el.childNodes[i].tagName && el.childNodes[i].tagName.toLowerCase() === 'table') {
			const table = document.createElement('table');
			table.innerHTML = el.childNodes[i].innerHTML;

			for (let r = 0, lr = table.rows.length; r < lr; r++) {
				for (let c = 0, lc = table.rows[r].cells.length; c < lc; c++) {
					table.rows[r].cells[c].innerHTML = addClassBrokenLink(table.rows[r].cells[c].innerHTML, links, CTRL_ID);
				}
			}

			el.childNodes[i].innerHTML = table.innerHTML;
		} else if (el.childNodes[i].tagName && el.childNodes[i].tagName.toLowerCase() === 'a') {
			const url = el.childNodes[i].getAttribute('href');
			const parseResult = new DOMParser().parseFromString(url, 'text/html');
			let href = parseResult.documentElement.textContent;
			// console.log(href, links.includes(href));
			// console.log('Find link', CTRL_ID, href)

			if (href) {
				// Приводим фронт и бек к одному формату
				if (href.endsWith('/')) href = href.slice(0, -1);
				href = href.replace(/\s+$/, '');

				const isMailLink = href.startsWith('mailto:');

				const linkIsBroken = isMailLink ? !!links.find((l) => href.includes(l)) : links.includes(href);
				const hasClassBroken = el.childNodes[i].classList.contains('broken-link');

				// console.log('Link is', CTRL_ID, href, linkIsBroken);

				// if (href && links.includes(href)) {
				if (linkIsBroken === true && hasClassBroken === false) {
					el.childNodes[i].classList.add('broken-link');
				} else if (linkIsBroken === false && hasClassBroken === true) {
					el.childNodes[i].classList.remove('broken-link');
				}
			}
		} else if (el.childNodes[i].hasChildNodes() && el.childNodes.length >= 1) {
			el.childNodes[i].innerHTML = addClassBrokenLink(el.childNodes[i].innerHTML, links, CTRL_ID);
		}
	}

	return el.innerHTML;
}
</script>

<style>
i[style="background-image: url('/uarm-fe/uarm-images/tinymce-typograph.png')"] {
	width: 48px;
}
.tooltip-ask {
	width: 20px;
	height: 14px;
	display: inline-block;
}
</style>
